import React from 'react'
import Image from 'next/image'
import { useTranslation } from 'react-i18next'
import * as S from './SectionEstudanteProfissional.styles'

const SectionEstudanteProfissional = () => {
  const { t } = useTranslation()

  return (
    <S.Section>
      <S.Title>{t('landingV2.sectionEstudanteProfissional.title')}</S.Title>
      <S.Subtitle>
        {t('landingV2.sectionEstudanteProfissional.subtitle')}
      </S.Subtitle>
      <S.Row>
        <S.ImageCol>
          <Image
            src={`${process.env.CDN_URL}/public/landingpagev2/images/section-estudante.png`}
            alt="Do estudante ao profissional"
            width={514}
            height={514}
            style={{ maxWidth: '100%', height: 'auto', width: 'auto' }}
            priority
          />
        </S.ImageCol>
        <S.TextCol>
          <li>
            <S.ListItemText>
              <S.ListItemBold>
                {t(
                  'landingV2.sectionEstudanteProfissional.bullets.otimizacao.title'
                )}
              </S.ListItemBold>
              {t(
                'landingV2.sectionEstudanteProfissional.bullets.otimizacao.text'
              )}
            </S.ListItemText>
          </li>
          <li>
            <S.ListItemText>
              <S.ListItemBold>
                {t(
                  'landingV2.sectionEstudanteProfissional.bullets.potencializacao.title'
                )}
              </S.ListItemBold>
              {t(
                'landingV2.sectionEstudanteProfissional.bullets.potencializacao.text'
              )}
            </S.ListItemText>
          </li>
          <li>
            <S.ListItemText>
              <S.ListItemBold>
                {t(
                  'landingV2.sectionEstudanteProfissional.bullets.recurso.title'
                )}
              </S.ListItemBold>
              {t('landingV2.sectionEstudanteProfissional.bullets.recurso.text')}
            </S.ListItemText>
          </li>
          <li>
            <S.ListItemText>
              <S.ListItemBold>
                {t(
                  'landingV2.sectionEstudanteProfissional.bullets.praticidade.title'
                )}
              </S.ListItemBold>
              {t(
                'landingV2.sectionEstudanteProfissional.bullets.praticidade.text'
              )}
            </S.ListItemText>
          </li>
          <li>
            <S.ListItemText>
              <S.ListItemBold>
                {t(
                  'landingV2.sectionEstudanteProfissional.bullets.disponivel.title'
                )}
              </S.ListItemBold>
              {t(
                'landingV2.sectionEstudanteProfissional.bullets.disponivel.text'
              )}
            </S.ListItemText>
          </li>
        </S.TextCol>
      </S.Row>
    </S.Section>
  )
}

export default SectionEstudanteProfissional
